import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export interface ISizeDefinition {
  id: string
  sizeScaleId: string
  code: string
  label: string
  numericValue: string
  sortOrder: number
}

export interface ISizeScale {
  id: string
  businessId: string
  name: string
  description: string | null
  unit: string
  sortOrder: number
  isDefault: boolean
  isActive: boolean
  createdByUserId: string
  createdAt?: string
  updatedAt?: string
  definitions?: ISizeDefinition[]
}

export interface ISizeScalesResponse {
  rows: ISizeScale[]
  count: number
}

export interface ICreateSizeScaleInput {
  name: string
  description?: string | null
  unit?: string
  sortOrder?: number
  isDefault?: boolean
  isActive?: boolean
}

export const create = async (data: ICreateSizeScaleInput): Promise<ISizeScale> =>
  httpRequest.post("/ord/size-scale", data as any)

export const list = async (data: {
  filter?: { search?: string; isActive?: boolean; includeDefinitions?: boolean }
  offset?: { limit: number; skip: number }
  order?: Array<[string, string]>
}): Promise<ISizeScalesResponse> =>
  httpRequest.post("/ord/size-scale/list", data as any)

export const get = async (id: string): Promise<ISizeScale> =>
  httpRequest.get(`/ord/size-scale/${id}`)

export const update = async (id: string, patch: Partial<ICreateSizeScaleInput>): Promise<ISizeScale> =>
  httpRequest.put(`/ord/size-scale/${id}`, patch as any)

export const remove = async (id: string): Promise<{ removed: boolean; reason?: string }> =>
  httpRequest.del(`/ord/size-scale/${id}`)

// Spec §9.4 — nested SizeDefinition CRUD on a SizeScale (1S / 3S / 6S / 20S etc.).

export interface ICreateSizeDefinitionInput {
  code: string
  label: string
  numericValue: string | number
  sortOrder?: number
}

export const definitions = {
  list: async (sizeScaleId: string): Promise<{ rows: ISizeDefinition[]; count: number }> =>
    httpRequest.get(`/ord/size-scale/${sizeScaleId}/definitions`),

  get: async (sizeScaleId: string, definitionId: string): Promise<ISizeDefinition> =>
    httpRequest.get(`/ord/size-scale/${sizeScaleId}/definitions/${definitionId}`),

  create: async (sizeScaleId: string, input: ICreateSizeDefinitionInput): Promise<ISizeDefinition> =>
    httpRequest.post(`/ord/size-scale/${sizeScaleId}/definitions`, input as any),

  update: async (
    sizeScaleId: string,
    definitionId: string,
    patch: Partial<ICreateSizeDefinitionInput>,
  ): Promise<ISizeDefinition> =>
    httpRequest.put(`/ord/size-scale/${sizeScaleId}/definitions/${definitionId}`, patch as any),

  remove: async (sizeScaleId: string, definitionId: string): Promise<{ removed: boolean }> =>
    httpRequest.del(`/ord/size-scale/${sizeScaleId}/definitions/${definitionId}`)
}
